import { render, staticRenderFns } from "./VideoRecordPage.vue?vue&type=template&id=57576b12&scoped=true"
import script from "./VideoRecordPage.vue?vue&type=script&lang=js"
export * from "./VideoRecordPage.vue?vue&type=script&lang=js"
import style0 from "./VideoRecordPage.vue?vue&type=style&index=0&id=57576b12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57576b12",
  null
  
)

export default component.exports